import client from "./client";

const CarService = {};

CarService.get = function (data) {
  return client.get(`/car`, data);
};

CarService.getContracts = function () {
  return client.get(`/car/contracts`);
};

CarService.update = function (carId, data) {
  return client.put(`/car/${carId}`, data);
};

CarService.assignCar = function (contractId, data) {
  return client.put(`/car/assign-car/${contractId}`, data);
};

CarService.unassignCar = function (contractId, carId) {
  return client.put(`/car/unassign-car/${contractId}/${carId}`);
};

CarService.create = function (data) {
  return client.post(`/car`, data);
};

CarService.createDrivingNote = function (contractId, data) {
  return client.post(`/car/driving-note/${contractId}`, data);
};

CarService.delete = function (carId) {
  return client.del(`/car/${carId}`);
};

export default CarService;
